import './css/styles.scss';

function allaNyheterInit() {}

allaNyheterInit();
